<svg
  [attr.width]="size"
  [attr.height]="size"
  fill="none"
  viewBox="0 0 24 24"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M8 2C8.55228 2 9 2.44772 9 3V21C9 21.5523 8.55228 22 8 22C7.44772 22 7 21.5523 7 21V3C7 2.44772 7.44772 2 8 2ZM20 4C20.5523 4 21 4.44772 21 5V19C21 19.5523 20.5523 20 20 20C19.4477 20 19 19.5523 19 19V5C19 4.44772 19.4477 4 20 4ZM12 6C12.5523 6 13 6.44772 13 7V17C13 17.5523 12.5523 18 12 18C11.4477 18 11 17.5523 11 17V7C11 6.44772 11.4477 6 12 6ZM4 9C4.55228 9 5 9.44772 5 10V14C5 14.5523 4.55228 15 4 15C3.44772 15 3 14.5523 3 14V10C3 9.44772 3.44772 9 4 9ZM16 10C16.5523 10 17 10.4477 17 11V13C17 13.5523 16.5523 14 16 14C15.4477 14 15 13.5523 15 13V11C15 10.4477 15.4477 10 16 10Z"
    fill="currentColor"
  />
</svg>
